import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

import Container from 'components/Container';

const ColumnTwo = ({ left, right }) => {
  return (
    <Root>
      <Wrapper>
        <Column>{left}</Column>
        <Column>{right}</Column>
      </Wrapper>
    </Root>
  );
};

ColumnTwo.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
};

const Root = styled.div`
  display: flex;
`;

const Column = styled.div`
  width: 50%;
  padding: 40px;
  @media (max-width: ${media.md}) {
    padding: 20px 0;
    width: 100%;
  }
`;

const Wrapper = styled(Container)`
  display: flex;
  @media (max-width: ${media.md}) {
    display: block;
  }
`;

export default ColumnTwo;



// WEBPACK FOOTER //
// ./src/components/ColumnTwo.js